/**
 * EL ID DEL NEGOCIO, LEIDO DE LAS TRES FORMAS EN QUE LLEGA (ONB-BOTON-INVITACION-T1).
 *
 * QUE PASO. El boton de la invitacion de onboarding mandaba b.id y la ficha del negocio trae
 * business_id: viajaba vacio y el API respondia 400 ("No se pudo generar la invitacion de
 * onboarding" en pantalla). Medido el 17-sep: api_peticiones 15:32:22, POST
 * /api/v1/onboarding/invitations 400, con Josse parado en la ficha del Demo Nexo 1.5.
 *
 * La ficha viene de varias manos (el API en camelCase, la BD en snake_case, y vistas viejas
 * que ya traian id), asi que el id se lee de las tres y el primero que sirva manda. Es la
 * misma tolerancia que usamos al LEER en todo el panel: cuesta una linea y protege.
 *
 * Sin DOM: lo prueba scripts/check-invitacion-id.mjs.
 */

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** El id del negocio, o '' si de verdad no vino ninguno. */
export function idDelNegocio(negocio) {
  if (!negocio) return '';
  return texto(negocio.business_id) || texto(negocio.businessId) || texto(negocio.id);
}

/**
 * EL TOKEN DE LA INVITACION, LEIDO DENTRO DEL SOBRE (ONB-BOTON-INVITACION-T2, FINDING #16373).
 *
 * ApiBase entrega el cuerpo entero en res.data, y el API responde el 201 con su sobre
 * ApiResponse: {success, data: {token, businessId, status, createdAt}, message}. La vista pedia
 * res.data.token desde el PR 181: el token estaba un nivel mas adentro. Quedo dormido mientras
 * el id viajaba vacio (400); el 328 arreglo el id, el API empezo a dar 201 y la pantalla seguia
 * diciendo "no se pudo". Se lee del sobre, sin sobre y en PascalCase; '' si no vino.
 */
export function tokenDeLaInvitacion(res) {
  if (!res || !res.ok) return '';
  const cuerpo = res.data || {};
  const dentro = cuerpo.data || {};
  return texto(dentro.token) || texto(dentro.Token) || texto(cuerpo.token) || texto(cuerpo.Token);
}

/**
 * Por que no se pudo generar la invitacion, con el DETALLE que mande el API.
 * Un "no se pudo" a secas deja a quien mira sin saber si es el negocio, el permiso o la red.
 */
export function porQueNoHayInvitacion(res) {
  if (!res) return '';
  if (res.ok) {
    return tokenDeLaInvitacion(res) ? '' : 'El API la creo pero no devolvio el enlace. Avisale a soporte con la hora.';
  }
  const d = res.details || res.data || null;
  const delApi = [d?.detail, d?.title, d?.mensaje, d?.message, typeof res.error === 'string' ? res.error : res.error?.message]
    .map(texto)
    .find((t) => t !== '');
  const campos = d?.errors && typeof d.errors === 'object'
    ? Object.entries(d.errors).map(([campo, lista]) => `${campo}: ${[].concat(lista).join(' ')}`).join(' · ')
    : '';
  return [delApi || 'No pudimos hablar con la API.', campos].filter(Boolean).join(' — ');
}

/**
 * QUIEN PUEDE MANDAR LA INVITACION DE REGISTRO (Ares #39768). Desde nexo-api 704 POST /api/v1/onboarding/invitations
 * es solo admin; un boton que siempre falla para el dueno es una pantalla que miente. Regla espejo ENTERA de
 * nexo-api Security/AdminRolePolicy.IsAdmin: el rol admin, sin importar mayusculas ni espacios; dev NO cuenta.
 */
export function puedeInvitar(rol) {
  return texto(rol).toLowerCase() === 'admin';
}

/** Lo que lee el dueno en lugar del boton. */
export const INVITACION_LA_MANDA_NEXO = 'La invitación de registro al cliente la envía el equipo de Nexo.';
